import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { DashboardBackButton } from '@components/utils'
import { SECTION_NAMES } from '@constants/sectionNames'
import { ButtonClean, HeadContent, Skeleton } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { ConnectBar, type ConnectBarProps } from '../../components/ConnectBar/ConnectBar'

export type AppsStreamelementsViewProps = {
  connectBar: ConnectBarProps | undefined
}

export const AppsStreamelementsView = ({ connectBar }: AppsStreamelementsViewProps) => {
  return (
    <>
      <HeadContent title={SECTION_NAMES.appStreamElements} />
      <PageLayout size="tiny">
        <Dashboard.Section
          name={SECTION_NAMES.appStreamElements}
          title={
            <>
              Show stream alerts for product purchases and gifts via StreamElements.{' '}
              <ButtonClean
                label="Learn more"
                href="https://help.fourthwall.com/hc/en-us/articles/13331283282331-Using-Streamlabs-StreamElements-to-power-purchase-alerts"
                target="_blank"
              />
            </>
          }
          topContent={<DashboardBackButton label="Apps" to={routing.apps.self} />}
        >
          <div style={{ marginTop: 16 - 24, marginBottom: 40 }}>
            {connectBar ? (
              <ConnectBar {...connectBar} />
            ) : (
              <Skeleton>
                <Skeleton.Shape height={64} />
              </Skeleton>
            )}
          </div>
        </Dashboard.Section>
      </PageLayout>
    </>
  )
}
